export const KNOWLEDGE_STATUS = {
	KNOW: 'know',
	DONT_KNOW: 'dont_know',
};
